import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDishes } from '../actions';
import { getDishesByFilter, getIsFetched, getIsFetching } from '../selectors';

/**
 * Get data for dishes.
 *
 * Currently fetches all included dishes the first time around. Filtering is then
 * done in the selector.
 *
 * @param filter
 * @param status
 * @returns {[boolean, *]}
 */
const useDishes = (filter, status) => {
  // console.log(status,"use dishesh")
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  // const isFetched = useSelector(getIsFetched);
  const filterOnlyIncluded = { ...filter, isExcluded: false };
  const dishes = useSelector(
    getDishesByFilter(Object.keys(filter).length ? filterOnlyIncluded : {})
  );

  useEffect(() => {
    // if (!isFetched) {
    // }
    dispatch(fetchDishes(status));
  }, []);

  return [isFetching, dishes];
};

export default useDishes;
